import type { IBox } from '@/types/pack';

export const initialPosition = (
  list: IBox[],
  isTablet: boolean,
  firstPlay: boolean,
  isGameCompleted?: boolean,
) => {
  const everyAchievement = list?.every(
    ({ achievement }) => achievement !== null,
  );
  const every = list?.every(({ achievement, achievement_without_score }) =>
    everyAchievement
      ? achievement_without_score === null
      : achievement === null,
  );

  return isTablet
    ? {
        x: isGameCompleted || !every || firstPlay ? '0' : '-100%',
      }
    : {
        y: isGameCompleted || !every || firstPlay ? 0 : '100%',
      };
};

export const animatePosition = (
  isTablet: boolean,
  isGameCompleted?: boolean,
) =>
  isTablet
    ? {
        x: isGameCompleted ? '100%' : 0,
      }
    : {
        y: isGameCompleted ? '-100%' : 0,
      };
